module.exports = __webpack_public_path__ + "img/plusbg.8f2d07ed.png";